var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrevMonth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 17,
    height: 17,
    rx: 5,
    transform: "rotate(-180 17 17)",
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32818 12C9.2051 11.9608 9.11842 11.8717 9.03175 11.7808C8.0679 10.7884 7.10405 9.7977 6.14021 8.80881C6.02233 8.68765 5.96685 8.54867 6.02059 8.38296C6.04139 8.3206 6.08127 8.26001 6.12634 8.21369C7.12485 7.18381 8.12511 6.15572 9.12536 5.1294C9.29351 4.95657 9.51194 4.95835 9.68009 5.12584C9.75983 5.20424 9.83957 5.28442 9.91238 5.36995C10.0337 5.51605 10.0268 5.7174 9.90545 5.8635C9.88638 5.88667 9.86558 5.90627 9.84651 5.92765C9.03348 6.76331 8.22045 7.60075 7.40569 8.43641C7.38662 8.45601 7.36408 8.47205 7.32941 8.52016C7.35368 8.53263 7.38142 8.54154 7.39875 8.55936C8.22045 9.40214 9.04041 10.2467 9.86211 11.0913C10.0147 11.2481 10.0459 11.4655 9.91932 11.6134C9.79103 11.7648 9.66969 11.9287 9.47553 12C9.42526 12 9.37672 12 9.32818 12Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevMonth);
export default __webpack_public_path__ + "static/media/prevMonth.bdac1ddd64bdb304ca52c90b6ab57f7e.svg";
export { ForwardRef as ReactComponent };